import { useParams } from 'react-router-dom';
import { IChainTrendingCoin, ITokenInfo } from '@kattana-io/common';
import Header from '../MainPage/Header';
import TokenPairsTable from './TokenPairsTable';
import TokenAbout from '../../components/SEO/About';
import TokenNews from '../../components/SEO/News';
import TokenSidebar from '../../components/SEO/Sidebar';
import TokenTrendingCoins from '../../components/SEO/TrendingCoins';
import Modal from '../../components/Modal';
import usePriceChange from '../../components/Info/usePriceChange';
import { getPriceUSD, getTokenStatistics } from './helpers';

import '../../components/SEO/styles.scss';

interface ITokenProps {
  token: ITokenInfo;
  trendingCoins: Record<string, IChainTrendingCoin> | null;
}

const Token = ({ token, trendingCoins }: ITokenProps) => {
  const params = useParams();

  const priceUSD = getPriceUSD(params.address || '', token.pairs?.[0]);

  const { priceChangePercent } = usePriceChange(
    priceUSD,
    !!token.pairs?.[0].flipped,
    token.pairs?.[0].chain,
    token.pairs?.[0].address
  );

  return (
    <div className='seo_page'>
      <Header chartPicker={false} />
      <div className='seo_page__content'>
        <div className='seo_page__about_token'>
          <div className='seo_page__main'>
            <TokenAbout
              title={token.long_title}
              subTitle={token.title}
              slug={token.slug}
              logo={token.logo_url}
              priceUSD={priceUSD}
              priceChange={priceChangePercent}
              description={token.seo_text || ''}
              chain={params.chain}
              address={params.address}
            />
            <TokenSidebar
              slug={token.slug}
              priceUSD={priceUSD}
              chain={params.chain}
              address={params.address}
              converterTitle={`${token.title} Converter`}
              statisticsTitle={`${token.title} Price Statistics`}
              statistics={getTokenStatistics(token, priceUSD)}
              height={408}
            />
          </div>
        </div>
        <TokenPairsTable title={`${token.title} Markets`} pairs={token.pairs} />
        {token.news && token.news?.length > 0 && (
          <TokenNews news={token.news} />
        )}
        {trendingCoins && (
          <TokenTrendingCoins
            coins={trendingCoins}
            chain={params.chain || ''}
            address={params.address || ''}
          />
        )}
      </div>
      <Modal />
    </div>
  );
};

export default Token;
